import { useMediaDownload } from "@/api/media";
import { useRFS } from "@/api/rfs";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { DataInfo, DataInfoWithBadge } from "@/components/ui/data-info";
import { MISSING_ID_IN_ROUTE } from "@/utils/constant";
import { formatDateString } from "@/utils/helper/formatDate";
import { swalError, swalLoading } from "@/utils/lib/swal";
import { Link, useParams } from "react-router-dom";
import ClusterSummary from "./ClusterSummary";
import HistoryProfileHomepass from "./HistoryProfileHomepass";

export function InformationPanel() {
  const { id } = useParams();
  if (!id) {
    throw new Error(MISSING_ID_IN_ROUTE);
  }

  const { data: rfs } = useRFS({ id });
  const { mutate } = useMediaDownload();

  function handleDownload() {
    if (!rfs?.documentAbd) {
      return;
    }
    swalLoading.fire();

    mutate(
      {
        path: rfs.documentAbd,
        fileName: `ABD_${rfs?.clusterId}.kmz`,
      },
      {
        onSuccess: () => {
          swalLoading.close();
        },
        onError: () => {
          swalError.fire({
            text: "Failed to download ABD.kmz",
          });
        },
      },
    );
  }

  return (
    <>
      <Card>
        <CardHeader>
          <CardTitle>Information</CardTitle>
        </CardHeader>
        <CardContent className="grid gap-4 md:grid-cols-3">
          <DataInfoWithBadge label="Status Document" value={rfs?.status} />
          <DataInfo label="Project Name" value={rfs?.projectName} />
          <DataInfo
            label="Date Feeder Done"
            value={formatDateString(rfs?.dateFeederDone) ?? "-"}
          />
          <DataInfo label="Request ID" value={rfs?.requestId} />
          <DataInfo label="OLT ID" value={rfs?.oltId} />
          <DataInfo
            label="Date Olt Done"
            value={formatDateString(rfs?.dateOltDone) ?? "-"}
          />
          <DataInfo label="Cluster ID" value={rfs?.clusterId} />
          <DataInfo label="OLT Type" value={rfs?.oltType} />
          <DataInfo label="PIC Vendor" value={rfs?.picVendor?.username} />
          <DataInfo label="Cluster ID ABD" value={rfs?.clusterIdAbd} />
          <DataInfo label="ODN Type" value={rfs?.odnType} />
          <DataInfo
            label="PIC Linknet"
            value={rfs?.picLinknet?.username ?? "-"}
          />
          <DataInfo label="Drawing ID APD" value={rfs?.drawingIdApd} />
          <DataInfo label="Combine Status" value={rfs?.combineStatus} />
          <DataInfo
            label="Project Description"
            value={rfs?.projectDescription ?? "-"}
          />
          <DataInfo label="Drawing ID RFS (ABD)" value={rfs?.drawingIdAbd} />
          <DataInfo label="Permit ID" value={rfs?.permitId} />
          <DataInfo label="Remarks" value={rfs?.remarks ?? "-"} />
          <DataInfo label="Project ID" value={rfs?.projectId} />
          <DataInfo
            label="Total Residence Homepass"
            value={rfs?.totalResidenceHomepass}
          />
          <DataInfo
            label="Notes"
            value={rfs?.notes ?? rfs?.cancelReason ?? "-"}
          />
          <DataInfo label="City Town" value={rfs?.cityTown} />
          <DataInfo
            label="Total Bizz Homepass"
            value={rfs?.totalBizzHomepass}
          />
          <Link
            to={`/rfs/rfs/${rfs?.id}/log-history`}
            className="text-sm font-bold text-blue-500 underline"
          >
            Log History
          </Link>
          <DataInfo label="FDTID" value={rfs?.fdtId} />
          <DataInfo label="Total HP RFS (ABD)" value={rfs?.totalHpRfs} />
          <button
            className="flex text-sm font-bold text-blue-500 underline"
            onClick={handleDownload}
          >
            Download ABD.kmz
          </button>
        </CardContent>
      </Card>

      <HistoryProfileHomepass />

      <ClusterSummary />
    </>
  );
}
